module.exports = __webpack_public_path__ + "img/integrity.8bb61eea.svg";